export const ROLE = {
	INVISION_DESKTOP: 'desktop:access',
	DESKTOP_DATA_ANALYST: 'desktop:rulehandler',
	DESKTOP_APPROVER: 'desktop:approver',
	INTELLIGENCE: 'intelligence:access',
	USERS_RULES: 'reditor:access',
	ADMIN: 'ADMIN',
	SYSTEM_STAFF: 'um:access',
	USER_STAFF_ADMIN: 'config:access',
	ALL: ['desktop:access', 'intelligence:access', 'um:access', 'reditor:access', 'config:access'],
	NOTALLOWED: 'empty',
	SMART_ASSIGN_CAN_ACCESS: 'smartassign:access',
};

export enum PATH {
	INTELLIGENCE = 'intelligence',
	DESKTOP = 'desktop',
	IDENTITY_SYSTEM = 'identity-system',
	RULE_ENGINE = 'rule-engine',
	GLOBAL_CONFIGURATION = 'global-configuration',
	SMART_ASSIGN = 'smart-assign',
	UNAUTHORIZED = 'unauthorized',
	SYSTEM_INFO = 'system-info',
	APPRAISAL = 'appraisal'
}

export const AllowedSignalRModule = [
	PATH.INTELLIGENCE,
	PATH.DESKTOP
];

export const BASE_STATE: any = {
	intelligence: {
		intelligence: {
			inbox: {},
			isOrderImporter: false
		}
	},
	'appraisal-desktop': {
		appraisalDesktop: {
			desktopRules: {},
			inboxDesktop: {},
			orderDesktop: {}
		}
	},
	'appraisal-desktop-order': {
		appraisalDesktop: {
			desktopRules: {},
			inboxDesktop: {},
			orderDesktop: {}
		}
	},
	'global-configuration': {
		globalConfiguration: {
			acuity: {},
			appScope: {},
			classIntelligence: {},
			nexsys: {},
			valuTrust: {},
			nexsysMonitor: {},
			product: {}
		}
	},
	'rule-engine': {
		ruleEngine: {
			ruleEngine: {},
			companies: [],
			products: [],
			ruleSetList: {},
			ruleSearch: {},
			smartQC: {}
		}
	},
	'identity-system': null,
	'system-info': null,
};

export const SIGNAL_EXCEPTIONS_EVENTS = [
	// Intelligence
	'order.created',
	'request.changed',
	'order.resubmitted',
	'order.zipready',
	'order.ssrrulesready',
	'order.documentready',
	'order.documentfailed',
	// Desktop & future, rules-component force execution
	'order.rulesexecuted',
	'order.gseValidationResult',
	'order.gsefailed',
	'order.gseready',
	'order.reports-available-updated',
	'order.updatedFields'
];

export const CONFIG_API = '';
export const CONFIG_ROUTE = 'Utils';
